import React, { useState } from "react";
import { TextField, MenuItem, InputAdornment, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

const CountryCodeDropdown = ({
    formik,
    countryCodeData,
    name = "countryCode",
    id = "countryCode",
    label = "Country Code",
    error,
    helperText,
    roundedInputStyle,
}) => {
    const [search, setSearch] = useState("");

    const filteredCountries = countryCodeData.filter((country) =>
        country.name.toLowerCase().includes(search.toLowerCase()) ||
        country.code.toLowerCase().includes(search.toLowerCase()) ||
        country.dial_code.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            {label && (
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        marginBottom: "6px",
                        color: "#374151", // soft dark gray
                    }}
                >
                    {label}
                </Typography>
            )}
            <TextField
                name={name}
                id={id}
                select
                value={formik?.values?.[name] || ""}
                onChange={formik?.handleChange}
                error={error}
                helperText={helperText}
                sx={roundedInputStyle}
                fullWidth
                variant="outlined"
                size="small"
                SelectProps={{
                    displayEmpty: true,
                    MenuProps: {
                        autoFocus: false,
                    },
                }}
            >
                <MenuItem value="" disabled sx={{ display: "none" }}>
                    Select Country Code
                </MenuItem>

                <div style={{ padding: "8px", position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
                    <TextField
                        autoFocus
                        size="small"
                        placeholder="Search country..."
                        fullWidth
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                {filteredCountries.map((country) => (
                    <MenuItem key={country.code} value={country.dial_code}>
                        {`${country.dial_code} ${country.name}`}
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
};

export default CountryCodeDropdown;
